export default "__VITE_ASSET__DqqBUA8N__"